import React, { useState } from "react";
import "./groupingmodal.css";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { updateDefaultInvitation } from "../../../redux/reducers/eventSlice";
import {snackbarContext} from '../../helpers/Snakbar'


const DefaultInviteModal = ({ onClose, events }) => {
    const setStateSnackbarContext=React.useContext(snackbarContext)
    const dispatch=useDispatch()
    const [values, setValues] = useState({
       
    eventIds: events
        .filter(event => event.showInMainInvite)
        .map(event => event._id)
    });

    const handleEventSelection = (eventId, checked) => {

    setValues((prev) => {

        const updatedEventIds = checked
            ? [...prev.eventIds, eventId]
            : prev.eventIds.filter(id => id !== eventId);

        return {
            ...prev,
            eventIds: updatedEventIds
        };

    });

};

const handleSubmit = () => {

    dispatch(
    updateDefaultInvitation({

        values,

        setStateSnackbarContext,

        onClose

    })
);

}

    return (
        <div className="grouping-modal-overlay">

            <div className="grouping-modal-container">

                <div className="guest-modal">

                    <button
                        className="modal-close"
                        onClick={() => onClose(false)}
                    >
                        <CloseIcon />
                    </button>

                    <h2>Edit Default Invitation</h2>

                    <p className="modal-helper">
                        Choose which events should appear in your default invitation link.
                    </p>

                    <div className="event-selection">

                        <span className="event-heading">
                            Visible Events
                        </span>

                        <span className="event-helper">
                            Guests opening your default invitation will only see the selected events.
                        </span>

                        <div className="event-checkbox-list">

                            {events && events.length > 0 ? (

                                events.map(event => (

                                    <label
                                        className="single-event"
                                        key={event._id}
                                    >

                                      <input
    type="checkbox"
    checked={values.eventIds.includes(event._id)}
    onChange={(e) =>
        handleEventSelection(
            event._id,
            e.target.checked
        )
    }
/>

                                        <span>
                                            {event.eventName}
                                        </span>

                                    </label>

                                ))

                            ) : (

                                <p className="no-events-text">
                                    No events found.
                                </p>

                            )}

                        </div>

                    </div>

                    <button className="create-list-btn" onClick={handleSubmit}>
                        Update Default Invitation
                    </button>

                </div>

            </div>

        </div>
    );
};

export default DefaultInviteModal;